import useTextInput from '@/core/hooks/inputs/useTextInput/useTextInput';

export default useTextInput;
